import { historyOT as baseHistoryOT } from "components/organisms/editor/history/historyOt";
import { reviewTrackChangesTheme } from "components/organisms/manuscript/review/codemirror";

export function historyOT(currentDoc) {
    return [...baseHistoryOT(currentDoc), reviewTrackChangesTheme];
}

export default historyOT;
